import { render, staticRenderFns } from "./VesselTrialTestTable.vue?vue&type=template&id=eefef952&scoped=true&"
import script from "./VesselTrialTestTable.vue?vue&type=script&lang=js&"
export * from "./VesselTrialTestTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefef952",
  null
  
)

export default component.exports